const INVITES = {
  GET_ALL_WALLETS: "GET_ALL_WALLETS",
  FILTER_INVITES: "FILTER_INVITES",
  SEARCH_INVITES: "SEARCH_INVITES",
  STORE_WALLET: "STORE_WALLET",
  SHOW_WALLET: "SHOW_WALLET",
  SHOW_MY_WALLET: "SHOW_MY_WALLET",
  EDIT_INVITE: "EDIT_INVITE",
  DELETE_WALLET: "DELETE_WALLET",
  LOADING_WALLETS: "LOADING_WALLETS",
};

export default INVITES;
